import messages from "./en-CA";
import { flattenMessages } from "./intlUtils";

export default {
  intl: {
    locale: "en-CA",
    messages: flattenMessages(messages),
  },
};



// WEBPACK FOOTER //
// ./src/components/intl/intlInitialState.js